// ２．Reactの起動スイッチ
// ViteでReactを起動するための入り口　index.htmlから呼び出され、Appコンポーネントをrootに描画する司令塔の役割
import React from 'react';
import ReactDOM from 'react-dom/client'; // ReactDOM:Reactをブラウザに描画する
import './index.css';
import App from './App';  // 1. 表示したい部品(App)を読み込む
import reportWebVitals from './reportWebVitals';

// 2. HTMLの'root'というIDを持つ場所を取得し、
// 3. そこに <App /> コンポーネントを差し込んで表示せよ！

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
